import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";

/** Soft-deleted or reviewer-rejected comments stay out of review UI lists. */
export function isVisibleReviewComment(comment: BaseTicketComment): boolean {
  return !comment.isDeleted && comment.liked !== false;
}

export function visibleReviewComments(
  comments: BaseTicketComment[] | undefined,
): BaseTicketComment[] {
  return (comments ?? []).filter(isVisibleReviewComment);
}

export function visibleAiCommentCount(
  comments: BaseTicketComment[] | undefined,
): number {
  return visibleReviewComments(comments).filter((c) => c.isAI).length;
}

export function visibleHumanCommentCount(
  comments: BaseTicketComment[] | undefined,
): number {
  return visibleReviewComments(comments).filter((c) => !c.isAI).length;
}
